// auth/AuthContext.js
import { createContext, useContext, useState } from "react";
import {
  clearPersistedAuthSession,
  clearSessionAuth,
  persistAuthSession,
  restoreRememberedSession,
} from "./authStorage";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    restoreRememberedSession();
    return !!sessionStorage.getItem("JWT");
  });
  const [loading] = useState(false);

  const login = (data, options = {}) => {
    const { rememberMe = false } = options;
    console.log("Login data:", data);
    persistAuthSession(
      {
        isFirstTimeUser: data?.data?.isSetupCompleted,
        JWT: data?.data?.token,
        email: data?.data?.email,
        orgCode: data?.data?.organizations?.[0]?.orgCode,
        organization: data?.data?.organizations?.[0]?.organization,
        mainTenantId: data?.data?.tenantId,
        tenantId: data?.data?.tenantId,
        userName: data?.data?.userName,
        accessLevel: data?.data?.access,
      },
      rememberMe,
    );
    setIsAuthenticated(true);
  };
  const signup = (data, options = {}) => {
    const { rememberMe = false } = options;
    console.log("Sign Up data:", data);
    persistAuthSession(
      {
        JWT: data?.data?.token,
        isFirstTimeUser: data?.data?.isSetupCompleted,
        email: data?.data?.email,
        orgCode: data?.data?.orgCode,
        organization: data?.data?.organization,
        tenantId: data?.data?.tenantId,
        mainTenantId: data?.data?.tenantId,
        userName: data?.data?.userName,
      },
      rememberMe,
    );
    setIsAuthenticated(true);
  };

  const logout = () => {
    clearSessionAuth();
    clearPersistedAuthSession();
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider
      value={{ isAuthenticated, login, logout, loading, signup }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
